import {PageWrapper, TranslationTypography} from "../../components";

export default function WikiPage () {
  return (
      <PageWrapper>
        <TranslationTypography text="Wiki" variant='h3'/>
      </PageWrapper>
  )
}